import { createContext} from 'react';

export const MenuStatusContext = createContext(null);
